import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { CustStatusBadge } from "@/components/badges";
import { api, errMsg } from "@/lib/api";
import { todayLocal } from "@/lib/format";

const MODES = {
  berhenti: {
    title: "Ubah Status Menjadi Berhenti", btn: "Ya, ubah menjadi BERHENTI", cls: "bg-rose-600 hover:bg-rose-700",
    desc: "Pelanggan tidak mendapat pasokan dari estimasi periode yang mencakup tanggal efektif dan sesudahnya. Penjualan aktual sebelum tanggal ini tetap dihitung. Riwayat, invoice lama, dan hutang tidak dihapus.",
  },
  aktif_kembali: {
    title: "Aktifkan Kembali Pelanggan", btn: "Ya, aktifkan kembali", cls: "bg-violet-700 hover:bg-violet-800",
    desc: "Data dan riwayat lama tetap dipakai, jadi tidak ada pelanggan ganda. Hutang lama tetap tercatat. Setelah ini, isi Pasokan Awal secara manual (tanpa tambahan 30%).",
  },
  aktif: {
    title: "Tetapkan Status AKTIF", btn: "Ya, tetapkan AKTIF", cls: "bg-emerald-700 hover:bg-emerald-800",
    desc: "Mulai periode berikutnya, pelanggan mengikuti estimasi reguler (penjualan aktual × 130%).",
  },
};

export function CustomerStatusDialog({ target, onClose, onDone }) {
  const [date, setDate] = useState(todayLocal());
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (target) { setDate(todayLocal()); setNote(""); }
  }, [target]);
  if (!target) return null;
  const m = MODES[target.mode];
  const needNote = target.mode !== "aktif";
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/customers/${target.customer.id}/status`, { status: target.mode, effective_date: date, note });
      toast.success(`Status ${data.name} diubah & tercatat di audit log`);
      onDone(data, target.mode);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="customer-status-dialog">
        <DialogHeader>
          <DialogTitle>{m.title}</DialogTitle>
          <DialogDescription>{m.desc}</DialogDescription>
        </DialogHeader>
        <div className="text-sm flex items-center gap-2"><b>{target.customer.name}</b> <CustStatusBadge status={target.customer.status} /> → <CustStatusBadge status={target.mode} /></div>
        <div><Label>Tanggal efektif</Label><Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="h-11" data-testid="status-date-input" /></div>
        <div><Label>Catatan / alasan {needNote ? "(wajib)" : "(opsional)"}</Label><Textarea rows={2} value={note} onChange={(e) => setNote(e.target.value)} data-testid="status-note-input" /></div>
        <DialogFooter>
          <Button onClick={submit} disabled={busy || !date || (needNote && note.trim().length < 3)} className={`h-11 ${m.cls}`} data-testid="status-submit-btn">{m.btn}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
